module.exports = __webpack_public_path__ + "img/img.27bcd0ab.png";